exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:37.4375rem){.ds-table-collapse thead{border:none;clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);height:.0625rem;overflow:hidden;position:absolute;visibility:hidden;width:.0625rem}.ds-table-collapse tr{border-top:var(--ds-border-rule--emphasised)}.ds-table-collapse td{display:block}.ds-table-collapse td:before{content:attr(data-label);float:left;font-weight:700;min-width:10rem}}", ""]);

// exports
exports.locals = {
	"ds-table-collapse": "ds-table-collapse"
};